var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rename-icon 1",
    clipPath: "url(#clip0_7529_1476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rename-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M11.7749 0L16.5 12.294V19.7415L15.2181 16.4142H5.7007L2.7935 24H0L9.29002 0H11.7749ZM17.25 24C16.8358 24 16.5 23.6642 16.5 23.25C16.5 22.8358 16.8358 22.5 17.25 22.5H19.5V1.5H17.25C16.8358 1.5 16.5 1.16421 16.5 0.75C16.5 0.335786 16.8358 0 17.25 0L23.25 0C23.6642 0 24 0.335786 24 0.75C24 1.16421 23.6642 1.5 23.25 1.5L21 1.49925V22.5H23.25C23.6642 22.5 24 22.8358 24 23.25C24 23.6642 23.6642 24 23.25 24H17.25ZM10.4756 2.89373C10.3674 3.3406 10.251 3.78474 10.1264 4.22616C10.0019 4.66757 9.88012 5.07629 9.76102 5.45232C9.64192 5.82834 9.53906 6.14714 9.45244 6.40872L6.62645 13.9455H14.3898L11.6125 6.40872C11.5476 6.21253 11.442 5.89101 11.2958 5.44414C11.1497 4.99728 11.0008 4.53406 10.8492 4.0545C10.6976 3.57493 10.5731 3.18801 10.4756 2.89373Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7529_1476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.dbab674bc50a7f018d1d6d5e96e6c3fd.svg";
export { ForwardRef as ReactComponent };